import React from 'react'
import styled from 'styled-components'
import { colors } from '../theme'
type Props = {
  type: string,
  size?: number,
  color?: string,
  onClick?: (e: React.MouseEvent<HTMLElement>) => void,
  disabled?: boolean,
  hasHover?: boolean,
}

interface StyledIconProps {
  size?: number
  color?: string
  disabled?: boolean
  hasHover?: boolean
}

const StyledIcon = styled.i<StyledIconProps>`
  font-size: ${(props) => `${props.size || 14}px`};
  color: ${(props) => (props.disabled ? colors.borders : props.color || 'white')};
  display: flex;
  justify-content: center;
  align-items: center;
  user-select: none;
  --webkit-user-select: none;
  --moz-user-select: none;
  --ms-user-select: none;
  background-color: transparent;
  border-radius: 50%;
  padding: 5px;
  transition: background-color 0.4s ease;

  ${({ hasHover }) =>
    hasHover &&
    `
    &:hover {
      background-color: ${colors.borders};
    }
  `}
`

function Icon({ type, size, color, onClick, disabled, hasHover }: Props) {
  return (
    <StyledIcon
      className="material-icons"
      size={size}
      color={color}
      onClick={disabled ? undefined : onClick}
      disabled={disabled}
      hasHover={hasHover}
    >
      {type}
    </StyledIcon>
  )
}

export default Icon
